import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { WHATSAPP_NUMBER, waLink } from '../analytics';

const Footer = () => {
  // SEO Schema Data for LocalBusiness
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "PT Cakra Digital Innovation",
    "description": "Technology Solutions & Digital Transformation Company yang fokus pada AI, Cloud, Managed IT Services, Cyber Security, dan Software Engineering untuk enterprise Indonesia",
    "url": "https://cakra-digital-innovation.com",
    "telephone": "+62-857-7620-3499",
    "email": "cdiyunoru@gmail.com",
    "logo": "https://cakra-digital-deploy.vercel.app/images/logo-Cakra/logo-cakra-digital-innovation-web-developer-indonesia.png",
    "image": "https://cakra-digital-deploy.vercel.app/images/logo-Cakra/logo-cakra-digital-innovation-web-developer-indonesia.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Taman Raya Rajeg Blok K16 No. 21, RT 018/RW 007, Mekarsari, Rajeg",
      "addressLocality": "Tangerang",
      "addressRegion": "Banten",
      "postalCode": "15540",
      "addressCountry": "ID"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "-6.132746360129017",
      "longitude": "106.52304347581214"
    },
    "openingHours": [
      "Mo-Fr 09:00-17:00",
      "Sa 09:00-14:00"
    ],
    "priceRange": "$$",
    "sameAs": [
      `https://wa.me/${WHATSAPP_NUMBER}`
    ],
    "keywords": "software engineering, AI automation, cloud solutions, digital visibility, managed IT services, website maintenance, technology solutions Indonesia, digital transformation company",
    "areaServed": {
      "@type": "Place",
      "name": "Indonesia"
    },
    "serviceType": [
      "Software Engineering",
      "AI & Automation",
      "Cloud Solutions",
      "Digital Visibility",
      "Managed IT Services",
      "Website Maintenance"
    ]
  };

  return (
    <>
      {/* SEO Schema Data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      
      <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="brand-logo">
              <div className="logo-icon">C</div>
              <span className="brand-text">Cakra Digital Innovation</span>
            </div>
            <p className="footer-tagline">Technology Solutions & Digital Transformation Company</p>
            <p className="footer-location">Taman Raya Rajeg Blok K16 No. 21, RT 018/RW 007, Mekarsari, Rajeg, Tangerang, Banten 15540</p>
            <p className="footer-legal">
              PT Cakra Digital Innovation terdaftar resmi dengan NIB 2005260092859, KBLI 62090, dan beroperasi sebagai perusahaan berbadan hukum sejak 20 Mei 2026.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Layanan</h4>
            <ul>
              <li><a href="/services#software-engineering">Software Engineering</a></li>
              <li><a href="/services#ai-automation">AI & Automation</a></li>
              <li><a href="/services#cloud-solutions">Cloud Solutions</a></li>
              <li><a href="/services#digital-visibility">Digital Visibility</a></li>
              <li><a href="/services#managed-it">Managed IT Services</a></li>
              <li><a href="/website-maintenance">Website Maintenance</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Perusahaan</h4>
            <ul>
              <li><Link to="/tentang">Tentang Kami</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/blog">Artikel & Blog</Link></li>
              <li><Link to="/consultation">Kontak</Link></li>
              <li><Link to="/pricing">Harga</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Hubungi Kami</h4>
            <div className="footer-contact">
              <div className="contact-primary">
                <div className="contact-item contact-item-primary">
                  <div className="contact-icon">
                    <Phone size={16} />
                  </div>
                  <div className="contact-info">
                    <span className="contact-label">WhatsApp</span>
                    <a 
                      href={waLink()} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="contact-value contact-whatsapp"
                    >
                      +62 857-7620-3499
                    </a>
                  </div>
                </div>
                
                <div className="contact-item contact-item-primary">
                  <div className="contact-icon">
                    <Mail size={16} />
                  </div>
                  <div className="contact-info">
                    <span className="contact-label">Email</span>
                    <a 
                      href="mailto:cdiyunoru@gmail.com"
                      className="contact-value contact-email"
                    >
                      cdiyunoru@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="contact-secondary">
                <div className="contact-item contact-item-secondary">
                  <div className="contact-icon">
                    <MapPin size={16} />
                  </div>
                  <div className="contact-info">
                    <span className="contact-label">Lokasi</span>
                    <span className="contact-value">Taman Raya Rajeg Blok K16 No. 21, RT 018/RW 007, Mekarsari, Rajeg, Tangerang, Banten 15540</span>
                  </div>
                </div>
                
                <div className="contact-item contact-item-secondary">
                  <div className="contact-icon">
                    <Clock size={16} />
                  </div>
                  <div className="contact-info">
                    <span className="contact-label">Jam Kerja</span>
                    <span className="contact-value">Senin - Jumat, 09:00 - 17:00, Sabtu, 09:00 - 14:00</span>
                  </div>
                </div>

                {/* Google Maps SEO Widget */}
                <div className="contact-maps">
                  <div className="maps-container">
                    <iframe 
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4808.9359808768395!2d106.52304347581214!3d-6.132746360129017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a010fd9984015%3A0xf30939cfa9cbb97f!2sCakra%20Digital%20Innovation!5e1!3m2!1sid!2sid!4v1773069286977!5m2!1sid!2sid" 
                      width="100%" 
                      height="200" 
                      style={{border:0, borderRadius: '8px'}} 
                      allowFullScreen="" 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Cakra Digital Innovation - Web Developer Indonesia di Tangerang"
                      aria-label="Peta lokasi kantor Cakra Digital Innovation di Tangerang, Banten"
                      className="maps-iframe"
                    />
                    <div className="maps-overlay">
                      <a 
                        href="https://maps.google.com/?q=Cakra+Digital+Innovation+Tangerang"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="maps-link"
                        title="Buka lokasi Cakra Digital Innovation di Google Maps"
                      >
                        <MapPin size={14} />
                        <span>Buka di Google Maps</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="footer-response">Respon cepat pada jam kerja.</p>
            <p className="footer-notice">📝 Form layanan sedang dalam pengembangan. Untuk respon cepat, hubungi langsung via WhatsApp.</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2026 PT Cakra Digital Innovation. All Rights Reserved.</p>
            <p className="footer-mission">
              Dibangun dengan komitmen pada kualitas, transparansi, dan pertumbuhan berkelanjutan.
            </p>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
